import core from './core';

export default {
  get({ search, page, per_page, sort, direction, withData, updated_before, } = {}) {
    return core.get('news', {
      params: { search, page, per_page, sort, direction, withData, updated_before, }
    });
  },

  getUnread(locale) {
    return core.get('news/unread', {
      params: { locale }
    });
  },

  read(id) {
    return core.post(`news/${id}`);
  }
}
